/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Attribute_CompletenessInputs */

const en_nav_attribute_completeness = /** @type {(inputs: Nav_Attribute_CompletenessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute completeness`)
};

/**
* | output |
* | --- |
* | "Attribute completeness" |
*
* @param {Nav_Attribute_CompletenessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_attribute_completeness = /** @type {((inputs?: Nav_Attribute_CompletenessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Attribute_CompletenessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_attribute_completeness(inputs)
});